<template>
  <b-container class="animated fadeIn mb-5">

    <template v-if="isHomepageEmpty">
      <h5 class="clickable">{{ $t('homepageWelcome')}} </h5>
    </template>

    <template v-else>
      <template v-if="bookmarks.length && $can('dashboard access')">
        <b-row align-h="center">
          <b-col class="clickable" sm="12" align-v="center" >
            <h5 class="mt-1 mb-4"> {{ $t('bookmarks') }} </h5>
          </b-col>

          <b-col cols="12">
            <b-row align-h="center">
              <b-col v-for="bookmark in bookmarks" :key="bookmark.uuid" cols="4" md="3" lg="2" xl="1">
                <HomeIcon :item="bookmark"  @open="openComponent"/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <hr/>
      </template>

      <b-row v-if="apps.length > 0" align-h="center">
        <b-col class="clickable" cols="12" align-v="center">
          <h5 class="mt-1 mb-4"> {{ $t('apps') }} </h5>
        </b-col>

        <b-col cols="12">
          <b-row align-h="center">
            <b-col v-for="app in apps" :key="app.uuid" class="mt-3"  cols="4" md="3" lg="2" xl="1">
              <HomeIcon  :item="app" @open="openApp"/>
            </b-col>

            <b-col cols="12"><hr /></b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="components.length > 0" align-h="center">
        <b-col class="clickable" cols="12">
          <h5 class="mt-1 mb-4"> {{ $t('components') }} </h5>
        </b-col>

        <b-col cols="12">
          <b-row align-h="center">
            <b-col v-for="component in components" :key="component.uuid" class="mt-3" cols="4" md="3" lg="2" xl="1">
              <HomeIcon :item="component" @open="openComponent" />
            </b-col>

            <b-col cols="12"><hr /></b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <RenderEvent event="home" key="integrations_home">
          <template v-slot:header="{ elements }">
            <b-col class="clickable mb-4" cols="12" align-v="center" v-if="elements.length > 0">
              <h5 > {{ $t('integrations.title') }} </h5>
            </b-col>
          </template>

          <template v-slot:component="{ context }">
            <b-col cols="12" md="3" lg="2" xl="1">
              <HomeIcon :item="context" @open="openIntegration" />
            </b-col>

          </template>

        </RenderEvent>
      </b-row>
    </template>
  </b-container>
</template>

<style scoped lang="scss">
.clickable {
  text-align: center;
  cursor: pointer;
}

.home-app {
  background-color: #2F353A;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  margin-top: 20px;

  &:hover {
    box-shadow: none;
  }
}
</style>

<script>
import Base from '../components/widgets/Base'
import RenderEvent from '../components/integrations/RenderEvent'
import Icon from './home/Icon'

export default {
  name: 'home',
  components: {
    Base,
    RenderEvent,
    HomeIcon: Icon,
  },
  data: function () {
    return {}
  },
  computed: {
    apps() {
      return this.$store.getters.getApps
    },

    bookmarks: {
      get() {
        let bookmarks = _.get(this.$store.getters.projectUserConfig("bookmarks"), "data", {})

        return Object.values(bookmarks).map(c => {
          return this.$store.getters.componentsMenu.find(f => {
              return c.name == f.name
          })
        }).filter(b => {
          if (!b) return false
          
          if (!b.is_active) {
            return false
          }

          if (b.is_public && this.$store.getters.isLiveEnv) {
            return true
          }

          return !this.$store.getters.isLiveEnv
        })
      },

      set(val) {
        let bookmarks = {}
        Object.values(val).forEach(v => {
          bookmarks[v.name] = v
        })

        this.$store.dispatch('updateProjectUserConfig', {path: "bookmarks", data: bookmarks})
      }
    },


    components() {
      let componentsMenu = this.$store.getters.componentsMenu.filter(c => {
        return c.is_public
      })

      componentsMenu.sort((a, b) => {
        return a.sort - b.sort
      })

      return componentsMenu
    },

    isHomepageEmpty() {
      return (this.components.length + this.bookmarks.length + this.apps.length) < 1
    }
  },
  methods: {
    openApp(app) {
      this.$router.push(`/app/${app.name}`)
    },

    openBookmark(bookmark) {
      this.$router.push(bookmark.url)
    },

    openIntegration(int) {
      this.$router.push(`/admin/integrations/page/${int.id}`)
    },

    openComponent(component) {
      let ref = component.name
      if (component.scope) {
        ref = `${component.scope}/${ref}`
      }

      this.$router.push(`/home/component/${ref}`)
    },

    openPortal(portal) {
      const pattern = this.$env.get("PORTAL_URL_PATTERN")
      const link = pattern.replaceAll("{name}", portal.name)
      const project = this.$store.getters.getCurrentProject
      const env = this.$store.getters.getCurrentEnv

      window.open(`${link}/#/?project=${project.uuid}&env=${env}`, "_blank")
    }
  }
}
</script>
